import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  FormControl,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  Select,
  Popover,
  Autocomplete,
  TextField,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "react-bootstrap";
import { SlOptions } from "react-icons/sl";
import { usePersistentFilter } from "../../assets/hooks/usePersistentFilter";
import { OffcanvasBody, Offcanvas } from "react-bootstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CustomTasksCalender } from "./CustomTasksCalender";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../ThemeContext";
import { useSelector } from "react-redux";
import SearchBar, { useDebounce } from "../../components/SearchBar";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import OutlinedInput from "@mui/material/OutlinedInput";
import Delete from "../../assets/images/tasks/DeleteIcon.png";
import { toast } from "react-toastify";
import { deleteCommentEntities, filterEntities } from "../../apis/apiService";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { format, startOfDay, endOfDay, } from "date-fns";
import { IoCloseOutline } from "react-icons/io5";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import {
  useFetchAllDepartmentsQuery,
  useFetchCreateOrUpdateTaskAllocationMutation,
  useFetchDuplicateTaskAllocationQuery,
  // useFetchGetallDepartmentsQuery,
  useFetchGetallManagersQuery,
  useFetchGetallProjectsQuery,
  useFetchTaskAllocationQuery,
  useFetchUserAccessedProjectsQuery,
} from "../../slice/logdetailSlice";
import Loader from "../../components/common/Loader";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import StaffInfoCard, { DraftCards } from "./StaffInfoCard";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { CiExport } from "react-icons/ci";
import { CommonDelete } from "../../components/common/CommonDelete";
// import { MdEditDocument } from "react-icons/md";
import CloseIcon from "@mui/icons-material/Close";
import { SaveAltSharp } from "@mui/icons-material";
import { FiRefreshCw } from "react-icons/fi";
import CustomPaginationFooter from "../../components/common/taskallocationcomponents/CustomPaginationFooter";

const filterOptions = {
  status: [
    { label: "Bench", value: "BENCH" },
    { label: "Engaged", value: "ENGAGED" },
    { label: "Long-term", value: "LONG_TERM" },
    { label: "Shortly Available", value: "SHORTLY_AVAILABLE" },
  ],
  department: [
    { label: "All", value: 1 },
    { label: "Backend", value: 2 },
    { label: "Bussiness Analyst", value: 3 },
    { label: "Frontend", value: 4 },
    { label: "Graphic & Video Editor", value: 5 },
    { label: "Mobile Application", value: 6 },
    { label: "Project Management", value: 7 },
    { label: "Tester", value: 8 },
  ],
  projectList: [
    { label: "Assurify", value: 1 },
    { label: "GPLG-PM & client tools", value: 2 },
    { label: "Job portal - Sixthstar", value: 3 },
    { label: "TT-PMS", value: 4 },
    { label: "TechnoTackle", value: 5 },
  ],
  workHours: [
    { label: "00", value: 0 },
    { label: "01", value: 1 },
    { label: "02", value: 2 },
    { label: "03", value: 3 },
    { label: "04", value: 4 },
    { label: "05", value: 5 },
    { label: "06", value: 6 },
    { label: "07", value: 7 },
    { label: "08", value: 8 },
    { label: "09", value: 9 },
    { label: "10", value: 10 },
  ],
  projectManager: [
    { label: "Suresh Babu", value: 1 },
    { label: "Balaakrishnan", value: 2 },
  ],
};

function TasksAllocationsTab() {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
// const [selectionRange, setSelectionRange] = useState(() => {
//   const saved = localStorage.getItem("taskAllocations_date_range");

//   if (saved) {
//     try {
//       const parsed = JSON.parse(saved);
//       return {
//         ...parsed,
//         startDate: new Date(parsed.startDate),
//         endDate: new Date(parsed.endDate),
//       };
//     } catch (error) {
//       console.error("Invalid stored date range:", error);
//     }
//   }

//   // default value if nothing in localStorage
//   return {
//     startDate: new Date(),
//     endDate: new Date(),
//     key: "selection",
//   };
// });


  const [storedRange, setStoredRange] = usePersistentFilter("taskAllocationSelectionRange", {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const selectionRange = useMemo(() => ({
    ...storedRange,
    startDate: new Date(storedRange.startDate),
    endDate: new Date(storedRange.endDate),
  }), [storedRange]);

  const setSelectionRange = setStoredRange;

// useEffect(() => {
//   // save to localStorage whenever selectionRange changes
//   localStorage.setItem("taskAllocations_date_range", JSON.stringify(selectionRange));
// }, [selectionRange]);

  const [shouldAutoSave, setShouldAutoSave] = useState(false);

  const [duplicateDateRange, setDuplicateDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "duplicate",
  });
  const [editedTasks, setEditedTasks] = useState({});
  const [enableAssign, setEnableAssign] = useState(false);
  const [tableRows, setTableRows] = useState([]);
  const [duplicatedRows, setDuplicatedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clndrOpen, setClnderOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showStaffInfo, setShowStaffInfo] = useState(false);
  const [showDrafts, setShowDrafts] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [anchorElOptions, setAnchorElOptions] = useState(null);
  const [publish, setPublish] = useState(false);

  
  const openOptions = Boolean(anchorElOptions);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const intervalRef = useRef(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 200,
  });
  const saveTimeouts = useRef({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [selectedWorkHours, setSelectedWorkHours] = useState(8);
  const [exportFormat, setExportFormat] = useState(undefined);
  const [refreshKey, setRefreshKey] = useState(0);
  const [nameColumnWidth, setNameColumnWidth] = useState(220);

  // Refs for drag-resize of Name column
  const nameColRef = useRef(null);
  const isResizing = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const handleNameColMouseDown = (e) => {
    isResizing.current = true;
    startX.current = e.clientX;
    startWidth.current = nameColumnWidth;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    const handleMouseMove = (moveEvent) => {
      if (!isResizing.current) return;
      const diff = moveEvent.clientX - startX.current;
      const newWidth = Math.max(10, Math.min(500, startWidth.current + diff));
      setNameColumnWidth(newWidth);
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const [departmentFilter, setDepartmentFilter] =   usePersistentFilter("taskAllocationDepartmentFilter", null);
  const date = dayjs(selectionRange.startDate).format("YYYY-MM-DD");
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const allowedPageSizes = [50, 75, 100];

  const safePaginationModel = {
    ...paginationModel,
    pageSize: allowedPageSizes.includes(paginationModel.pageSize)
      ? paginationModel.pageSize
      : 50, // fallback if someone somehow has 200 cached
  };

  const {
    data: task_allocation_data = [],
    refetch: task_allocation_refetch,
    isLoading: task_alocation_loading,
  } = useFetchTaskAllocationQuery(
    {
      date: date,
      department_id: departmentFilter || "",
      search: debouncedSearchTerm,
      export: exportFormat,
    },
    { skip: publish }
  );

  const {
    data: full_task_allocation_data = [],
    refetch: full_task_allocation_data_refetch,
  } = useFetchTaskAllocationQuery({
    date: date,
    department_id: departmentFilter || "",
    export: exportFormat,
  }, { skip: publish });

  const {
    data: duplicate_task_allocation_data = [],
    refetch: duplicate_task_allocation_refetch,
    isLoading: _duplicate_task_alocation_loading,
  } = useFetchDuplicateTaskAllocationQuery(
    {
      original_date: format(selectionRange.endDate, "yyyy-MM-dd"),
      new_date: format(selectionRange.startDate, "yyyy-MM-dd"),
      search: debouncedSearchTerm,
    },
    {
      skip: !selectionRange.startDate || !selectionRange.endDate || !publish,
    }
  );

  const {
    data: full_duplicate_task_allocation_data = [],
    refetch: full_duplicate_task_allocation_refetch,

  } = useFetchDuplicateTaskAllocationQuery(
    {
      original_date: format(selectionRange.endDate, "yyyy-MM-dd"),
      new_date: format(selectionRange.startDate, "yyyy-MM-dd"),

    },
    {
      skip: !selectionRange.startDate || !selectionRange.endDate || !publish,
    }
  );

  // console.log("task_allocation_meta :", task_allocation_data?.meta);
  const [source,setSource]=useState(null)
  const [draft,setDraft]=useState(null)

  const [createOrUpdateAllocation, { isLoading: creating_allocation }] = useFetchCreateOrUpdateTaskAllocationMutation();
  const [autoSaveDraft] = useFetchCreateOrUpdateTaskAllocationMutation();
  // const { data: department_list = [], refetch: department_list_refetch } =
  //   useFetchGetallDepartmentsQuery();
  const { data: department_list = [], refetch: department_list_refetch } = useFetchAllDepartmentsQuery();
  const {
    data: allDepartments = [],
    refetch: fetch_all_departments,
    isError: fetchdepError,
  } = useFetchAllDepartmentsQuery();
  // useFetchAllDepartmentsQuery;

  const {
    data: project_list = [],
    refetch: projectNames,
    isLoading: project_loading,
  } = useFetchGetallProjectsQuery();

  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();
  const { data: manager_lists = [], refetch: manager_refetch } = useFetchGetallManagersQuery();
  // console.log("Task_allocations_is data??? :", manager_lists);
  const isAnyRowUpdated = tableRows.some((dept) =>
    dept.data.some((child) => child.isUpdated)
  );
  const AUTO_SAVE_DELAY = 500;
  const autoSaveTimeout = useRef(null);
  useEffect(() => {
    const isAnyRowUpdated = duplicatedRows.some((dept) =>
      dept.data.some((child) => child.isUpdated)
    );

    if (!isAnyRowUpdated) return;

    if (autoSaveTimeout.current) {
      clearTimeout(autoSaveTimeout.current);
    }
    autoSaveTimeout.current = setTimeout(() => {
      setShouldAutoSave(true);
    }, AUTO_SAVE_DELAY);
  }, [duplicatedRows]);

  useEffect(()=>{
    setDraft(duplicate_task_allocation_data?.meta?.is_draft)
    setSource(duplicate_task_allocation_data?.meta?.source)
    
  },[duplicate_task_allocation_data , selectionRange, publish])

   useEffect(()=>{
    
  },[draft,source])

  useEffect(()=>{
    setDraft(task_allocation_data?.meta?.is_draft)
    setSource(task_allocation_data?.meta?.source)
    // console.log("duplicate_source_draft full task allocation:",task_allocation_data);
  },[task_allocation_data,selectionRange,refreshKey])

  useEffect(() => {
    if (!publish) {
      task_allocation_refetch?.();
      full_task_allocation_data_refetch?.();
    }
  }, [selectionRange.startDate, departmentFilter, publish]);

  useEffect(() => {

    if (publish) {
      duplicate_task_allocation_refetch?.()
    }
    else {
      task_allocation_refetch?.();
      full_task_allocation_data_refetch?.();
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    department_list_refetch();

    projectNames();
    manager_refetch();
  }, []);

  useEffect(() => {
    if (publish) {
      // console.log("duplicat??>", selectionRange);
      duplicate_task_allocation_refetch();
      full_duplicate_task_allocation_refetch();
    }
  }, [selectionRange.startDate, departmentFilter]);

  const mapTaskAllocationData = (task_allocation_data) => {
    if (!task_allocation_data?.data?.length) {
      return [];
    }

    return task_allocation_data.data.map((dept, deptIndex) => ({
      department_name: dept.department_name || "",
      department_id: dept.department_id || null,
      count: dept.count || 0,
      isParent: true,
      data: dept.data.map((task, rowIndex) => ({
        user_name: task.user_name || "N/A",
        user_id: task.user_id || null,
        task_allocation_id: task.task_allocation_id || "N/A",
        date: task.date || "N/A",
        isParent: false,
        department: dept.department_name || "N/A",
        designation: task.designation || "N/A",
        work_status: task.work_status || "N/A",
        work_hours: task.work_hours || 0,
        work_till: task.work_till || null,
        relevant_experience: task.relevant_experience || "N/A",
        area_of_expertise: task.area_of_expertise || [],
        project_manager: task.project_manager?.name || "N/A",
        project_manager_id: task.project_manager?.user_id || "N/A",
        project_id: task.project?.project_id || null,
        project_title: task.project?.title || "N/A",
        task_list: task.task_list || "N/A",
        added_by: task.added_by || "N/A",
        updated_by: task.updated_by || "N/A",
        added_at: task.added_at || "N/A",
        updated_at: task.updated_at || "N/A",
        departmentIndex: deptIndex,
        rowIndex,
        isUpdated: false,
      })),
    }));
  };

  useEffect(() => {
    if (!publish) {
      const mappedRows = mapTaskAllocationData(task_allocation_data);
      setTableRows(mappedRows);
    }
  }, [task_allocation_data,refreshKey,publish]);


  useEffect(() => {
    if (!publish && full_task_allocation_data) {
      const mappedRows = mapTaskAllocationData(full_task_allocation_data);
      setDuplicatedRows(mappedRows);
    }
  }, [full_task_allocation_data,refreshKey,publish]);

// modified mapDuplicateTaskAllocationData this functin, if any issues we can revert this
  const mapDuplicateTaskAllocationData = (data) => {
    if (!data?.length) return [];

    // 🔄 Old code : 1
    // return data.map((dept, deptIndex) => ({
    //   department_name: dept.department_name || "",
    //   department_id: dept.department_id || "",
    //   count: dept.count || 0,
    //   isParent: true,
    //   // data: dept.data.map((task, rowIndex) => ({
    //     data: dept.data

    // 🔄 stop after duplicate records unwanted records shows
    return data
        .map((dept, deptIndex) => {
          // Source date-la valid allocation illatha tasks mattum filter pannanum
          const validTasks = dept.data
            .filter((task) => {
              // Source date-la valid allocation illatha users-a skip pannanum
              // (task_allocation_id null/undefined/"N/A" means no record on source date)
              const id = task.task_allocation_id;
              return id && id !== "N/A" && !String(id).startsWith("temp");
            })
            .map((task, rowIndex) => ({
              user_name: task.user_name || "N/A",
              user_id: task.user_id || null,
              task_allocation_id: task.task_allocation_id || "N/A",
              date: task.date || "N/A",
              isParent: false,
              department: dept.department_name || "N/A",
              designation: task.designation || "N/A",
              work_status: task.work_status || "N/A",
              work_hours: task.work_hours || 0,
              work_till: task.work_till || null,
              relevant_experience: task.relevant_experience || "N/A",
              area_of_expertise: task.area_of_expertise || [],
              project_manager: task.project_manager?.name || "N/A",
              project_manager_id: task.project_manager?.user_id || "N/A",
              project_id: task.project?.project_id || null,
              project_title: task.project?.title || "N/A",
              task_list: task.task_list || "N/A",
              added_by: task.added_by || "N/A",
              updated_by: task.updated_by || "N/A",
              added_at: task.added_at || "N/A",
              updated_at: task.updated_at || "N/A",
              departmentIndex: deptIndex,
              rowIndex,
              isUpdated: true,
              // 🔄Old code : 1
              //     })),
              // }));

              // 🔄 New code : 2
            }));
          return {
            department_name: dept.department_name || "",
            department_id: dept.department_id || "",
            count: validTasks.length,
            isParent: true,
            data: validTasks,
          };
        })
        // Valid tasks illatha departments-a completely filter out pannanum
        // (Refresh illama ne department header show aagaathu)
      .filter((dept) => dept.data.length > 0);
  };
  // 🔄 New code : 2

  useEffect(() => {
    if (publish) {
      if (duplicate_task_allocation_data?.data?.length) {
        const mappedRows = mapDuplicateTaskAllocationData(
          duplicate_task_allocation_data?.data
        );
        setTableRows(mappedRows);
     
      } else if (duplicate_task_allocation_data && !duplicate_task_allocation_data?.data?.length) {
        setTableRows([]);
      }
    }
  }, [duplicate_task_allocation_data, publish]);

  useEffect(() => {
    if (publish) {
      if (full_duplicate_task_allocation_data?.data?.length) {
        // console.log("full_duplicate_task_allocation_data",full_duplicate_task_allocation_data);
        const mappedRows = mapDuplicateTaskAllocationData(
          full_duplicate_task_allocation_data?.data
        );
        setDuplicatedRows(mappedRows);
        // console.log("fulltable_rows_duplicating ;", tableRows);
      } else if (full_duplicate_task_allocation_data && !full_duplicate_task_allocation_data?.data?.length) {
        setDuplicatedRows([]);
      }
    }
  }, [full_duplicate_task_allocation_data, duplicate_task_allocation_data, publish]);


  const handleSearchChange = async (event) => {
    const value = event.target.value;
    const trimmedValue = value.trim();
    setSearchTerm(value);

    if (trimmedValue) {
      setIsSearching(true);
      //  await fetchSearchedProjects(trimmedValue);
    } else {
      setIsSearching(false);
      //    await fetchProjects();
    }
  };
  // useEffect(() => {
  //   console.log("table_rows_duplicating_duplicatedRows:", duplicatedRows);
  // }, [duplicatedRows]);
  const updateRowField = (rowId, updatedFields) => {
    // console.log("table_rows_duplicating status name:", updatedFields);


    const updated = tableRows.map((dept) => ({
      ...dept,
      data: dept.data.map((child) => {
        if (child.task_allocation_id === rowId) {
          return {
            ...child,
            ...updatedFields, // Apply all fields at once
            isUpdated: true,
          };
        }
        return child;
      }),
    }));
    const updatedDuplicate = duplicatedRows.map((dept) => ({
      ...dept,
      data: dept.data.map((child) => {
        if (child.task_allocation_id === rowId) {
          return {
            ...child,
            ...updatedFields, // Apply all fields at once
            isUpdated: true,
          };
        }
        return child;
      }),
    }));
    setDuplicatedRows(updatedDuplicate);
    setTableRows(updated);

  };

  // const prepareTaskAllocations = (rows) => {
  //   const task_allocations = [];

  //   rows.forEach((dept) => {
  //     dept.data.forEach((row) => {
  //       if (row?.isNew && row?.baseRowSnapshot) {
  //         const unchanged =
  //           row.user_id === row.baseRowSnapshot.user_id &&
  //           row.project_id === row.baseRowSnapshot.project_id &&
  //           row.date === row.baseRowSnapshot.date &&
  //           row.work_status === row.baseRowSnapshot.work_status &&
  //           row.task_list === row.baseRowSnapshot.task_list &&
  //           row.work_hours === row.baseRowSnapshot.work_hours &&
  //           row.project_manager_id === row.baseRowSnapshot.project_manager_id &&
  //           row.work_till === row.baseRowSnapshot.work_till;

  //         if (unchanged) return; // Skip unchanged
  //       }

  //       const taskObj = {
  //         user_id: row.user_id,
  //         project_id: row.project_id,
  //         date: row.date,
  //         work_status: row.work_status,
  //         task_list: row.task_list,
  //         work_hours: row.work_hours,
  //         project_manager_id: row.project_manager_id,
  //         work_till: row.work_till
  //           ? format(new Date(row.work_till), "yyyy-MM-dd")
  //           : null,
  //       };

  //       if (
  //         row.task_allocation_id &&
  //         !String(row.task_allocation_id).startsWith("temp") &&
  //         !row.isNew
  //       ) {
  //         taskObj.task_allocation_id = row.task_allocation_id;
  //       }

  //       task_allocations.push(taskObj);
  //     });
  //   });

  //   return task_allocations;
  // };

  const prepareTaskAllocations = (rows) => {
  const task_allocations = [];
  let unchangedCount = 0; // 🔹 Track how many unchanged rows are skipped

  rows.forEach((dept) => {
    dept.data.forEach((row) => {
      let unchanged = false;

      // 🔹 Check only for existing rows (not new)
      if (!row?.isNew && row?.baseRowSnapshot) {
        unchanged =
          row.user_id === row.baseRowSnapshot.user_id &&
          row.project_id === row.baseRowSnapshot.project_id &&
          row.date === row.baseRowSnapshot.date &&
          row.work_status === row.baseRowSnapshot.work_status &&
          row.task_list === row.baseRowSnapshot.task_list &&
          row.work_hours === row.baseRowSnapshot.work_hours &&
          row.project_manager_id === row.baseRowSnapshot.project_manager_id &&
          row.work_till === row.baseRowSnapshot.work_till;
      }

      // 🔹 Skip unchanged rows
      if (unchanged) {
        unchangedCount++;
        return;
      }

      // 🔹 Include both new & changed rows
      const taskObj = {
        user_id: row.user_id,
        project_id: row.project_id,
        date: row.date,
        work_status: row.work_status,
        task_list: row.task_list,
        work_hours: row.work_hours,
        project_manager_id: row.project_manager_id,
        work_till: row.work_till
          ? format(new Date(row.work_till), "yyyy-MM-dd")
          : null,
      };

      // 🔹 Include task_allocation_id only for existing records
      if (
        row.task_allocation_id &&
        !String(row.task_allocation_id).startsWith("temp") &&
        !row.isNew
      ) {
        taskObj.task_allocation_id = row.task_allocation_id;
      }

      task_allocations.push(taskObj);
    });
  });

  // 🔹 Show a toast if all rows were unchanged
  if (task_allocations.length === 0) {
    toast.error("No changes detected in any rows.");
  } else if (unchangedCount > 0) {
    toast.info(`${unchangedCount} unchanged row(s) skipped.`);
  }

  return task_allocations;
};

  const prepareDraftAllocations = (rows) => {
    const departmentsMap = new Map();

    rows.forEach((dept) => {
      const departmentName = dept.department_name || "";

      if (!departmentsMap.has(departmentName)) {
        departmentsMap.set(departmentName, {
          department_name: departmentName,
          department_id: null, // Add if you have it
          count: 0,
          data: [],
        });
      }

      dept.data.forEach((row) => {
        // Optional change check logic (e.g., to skip unchanged rows)
        if (row?.isNew && row?.baseRowSnapshot) {
          const unchanged =
            row.user_id === row.baseRowSnapshot.user_id &&
            row.project_id === row.baseRowSnapshot.project_id &&
            row.date === row.baseRowSnapshot.date &&
            row.work_status === row.baseRowSnapshot.work_status &&
            row.task_list === row.baseRowSnapshot.task_list &&
            row.work_hours === row.baseRowSnapshot.work_hours &&
            row.project_manager_id === row.baseRowSnapshot.project_manager_id &&
            row.work_till === row.baseRowSnapshot.work_till;

          if (unchanged) return; // skip
        }

        const task = {
          task_allocation_id:
            row.task_allocation_id &&
              !String(row.task_allocation_id).startsWith("temp") &&
              !row.isNew
              ? row.task_allocation_id
              : null,
          date: row.date || null,
          user_id: row.user_id || null,
          user_name: row.user_name || "N/A",
          department: row.department || "",
          designation: row.designation || "N/A",
          date_of_joining: row.date_of_joining || null,
          work_status: row.work_status || "N/A",
          work_hours: row.work_hours || 0,
          work_till: row.work_till
            ? format(new Date(row.work_till), "yyyy-MM-dd")
            : null,
          area_of_expertise: row.area_of_expertise || [],
          relevant_experience: row.relevant_experience || null,
          project_manager: {
            user_id: row.project_manager_id || null,
            name: row.project_manager || "",
            email: "", // optionally include if available
          },
          project: row.project_id
            ? {
              project_id: row.project_id,
              title: row.project_title || "",
            }
            : null,
          project_id: row.project_id || null,
          task_list: row.task_list || null,
          added_by: row.added_by || null,
          updated_by: row.updated_by || null,
          added_at: row.added_at || "",
          updated_at: row.updated_at || "",
        };

        const departmentGroup = departmentsMap.get(departmentName);
        departmentGroup.data.push(task);
        departmentGroup.count = departmentGroup.data.length;
      });
    });

    return Array.from(departmentsMap.values());
  };

  useEffect(() => {
    if (!shouldAutoSave || !duplicatedRows?.length) return;

    const task_allocations = prepareDraftAllocations(duplicatedRows);
    if (task_allocations.length === 0) return;

    const autoSave = async () => {
      try {
        const isDuplicate = publish || task_allocation_data?.meta?.source === "DUPLICATE";
        const response = await autoSaveDraft({                                                                                 
          path: "task-allocation/drafts/autoSave",
          data: {
            date: date,
            data: task_allocations,
            // source:
            //   publish || task_allocation_data?.meta?.source === "DUPLICATE"
            //     ? "DUPLICATE"
            //     : "ASSIGN_TASK",
            source: isDuplicate ? "DUPLICATE" : "ASSIGN_TASK",
            original_date: isDuplicate ? format(selectionRange.endDate, "yyyy-MM-dd") : null,
          },
        }).unwrap();

        if (response) {
          setShouldAutoSave(false);
          // if(publish){
          //   duplicate_task_allocation_refetch()
          // }else{
          //   task_allocation_refetch()
          // }
      //       task_allocation_refetch?.();
      // full_task_allocation_data_refetch?.();
          // console.log("Auto-saved task allocations");
        }
      } catch (err) {
        console.error("Auto-save failed:", err);
      }
    };

    autoSave();
  }, [shouldAutoSave]);

  const handleAssignTasks = async () => {
    // console.log("assign_task_duplicate_rows :", duplicatedRows);

    const task_allocations = prepareTaskAllocations(duplicatedRows);
    // console.log("count",task_allocation_data);
    

     if (task_allocations.length === 0) return;
    // console.log(
    //   "assign_task_duplicate_rows task_allocations:",
    //   task_allocations
    // );

    try {
      const response = await createOrUpdateAllocation({
        path: "task-allocation/assignTasks",
        data: { task_allocations },
      }).unwrap();

      if (response) {
        department_list_refetch();
        task_allocation_refetch();
        full_task_allocation_data_refetch?.();
        toast.success(response.message);
        setSearchTerm("")
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.message || err?.data?.message);
    }

  };

  // useEffect(() => {
  //   // console.log("alocation_data ???? :", tableRows);
  // }, [tableRows]);

  const handlePublishAndSendMail = async () => {
    setLoading(true);
    const task_allocations = [];

    duplicatedRows.forEach((dept) => {
      dept.data.forEach((row) => {

        if ( row?.isNew && row?.baseRowSnapshot) {
          const unchanged =
            row.user_id === row.baseRowSnapshot.user_id &&
            row.project_id === row.baseRowSnapshot.project_id &&
            row.date === row.baseRowSnapshot.date &&
            row.work_status === row.baseRowSnapshot.work_status &&
            row.task_list === row.baseRowSnapshot.task_list &&
            row.work_hours === row.baseRowSnapshot.work_hours &&
            row.project_manager_id === row.baseRowSnapshot.project_manager_id &&
            row.work_till === row.baseRowSnapshot.work_till;

          // if (unchanged) return;
        }

        const taskObj = {
          user_id: row.user_id,
          project_id: row.project_id,
          date: row.date,
          work_status: row.work_status,
          task_list: row.task_list,
          work_hours: row.work_hours,
          project_manager_id: row.project_manager_id,
          work_till: row.work_till
            ? format(new Date(row.work_till), "yyyy-MM-dd")
            : null,
        };

        // Include task_allocation_id only if not temp/new
        if (
          row.task_allocation_id &&
          !String(row.task_allocation_id).startsWith("temp") &&
          !row.isNew
        ) {
          taskObj.task_allocation_id = row.task_allocation_id;
        }

        task_allocations.push(taskObj);
      });
    });
  
    try {
      // console.log("task_allocation",task_allocations)
      const response = await createOrUpdateAllocation({
        path: "task-allocation/duplicate-publish",
        data: {
          new_date: format(selectionRange.startDate, "yyyy-MM-dd"),
          task_allocations: task_allocations,
        },
      }).unwrap();
      if (response) {
        setPublish(false);

        department_list_refetch();
        setSearchTerm("");

        toast.success(response.message);
      
  if(!publish){
       await task_allocation_refetch?.();
       await full_task_allocation_data_refetch?.();   
  }}
    } catch (err) {
      toast.error(err?.message || err?.data?.message);
    } finally {
      setLoading(false);
    }

    // console.log("Filtered Payload:", { task_allocations });
  };


  const handleManagerChange = (event, rowId) => {
    const newManagerId = event.target.value;
    const selectedManager = manager_lists.find(
      (m) => m.user_id === newManagerId
    );

    updateRowField(rowId, {
      project_manager_id: newManagerId,
      project_manager: selectedManager?.name || "N/A",
    });
  };

  const handleStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    updateRowField(rowId, { work_status: newStatus });
  };

  const handleWorkHoursChange = (event, rowId) => {
    const newWorkHours = event.target.value;
    updateRowField(rowId, { work_hours: newWorkHours });
  };

  const handleClearFilter = () => {
    // fetchProjects();
  };
  const handleToggle = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  const handleDeleteConfirmed = async () => {
    // console.log("Deleting_task ID:", selectedTask);
    setLoading(true);
    try {
      const response = await deleteCommentEntities(
        "task-allocation/delete",
        selectedTask
      );
      if (response) {
        task_allocation_refetch();
        toast.success(response.message);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setOpenDeleteModal(false);
      setLoading(false);
    }
  };


  const getVisibleRows = () => {
    const visibleRows = [];

    tableRows?.forEach((row) => {
      visibleRows.push({
        id: row.department_name,
        name: row.department_name,
        count: row.count,
        isGroup: true,
      });

      if (expandedGroups[row.department_name]) {
        row.data.forEach((child) => {
          visibleRows.push({
            ...child,
            id: child.task_allocation_id,
            isGroup: false,
          });
        });
      }
    });

    return visibleRows;
  };

  const visibleRows = getVisibleRows();
  const paginatedRows = visibleRows.slice(
    paginationModel.page * paginationModel.pageSize,
    paginationModel.page * paginationModel.pageSize + paginationModel.pageSize
  );

  const onCloseStaffInfo = () => {
    setShowStaffInfo(!showStaffInfo);
  };
  const handleCloseDraft = () => {
    setShowDrafts(false);
  };
  const handleDeleteRow = (row) => {
    // console.log("params_date delete method :", row);

    setOpenDeleteModal(true);
    setSelectedTask({
      id: row?.id,
      name: row?.user_name,
      department: row?.department,
    });
    // setTableRows(updated);
  };

  const handleTaskChange = (id, value) => {
    // console.log("namechanges_val:", id, value);

    // Update the editedTasks state immediately
    setEditedTasks((prev) => ({
      ...prev,
      [id]: { ...prev[id], value },
    }));
    if (saveTimeouts.current[id]) {
      clearTimeout(saveTimeouts.current[id]);
    }
    saveTimeouts.current[id] = setTimeout(() => {
      handleTaskSave(id, value);
      delete saveTimeouts.current[id];
    }, 500);
  };
  const handleTaskSave = (id, latestValue) => {
    const updated = latestValue ?? editedTasks[id]?.value ?? "";

    updateRowField(id, { task_list: updated });

    setEditedTasks((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        original: updated,
        value: updated,
      },
    }));
    // console.log("namechanges_val_setEditedTasks: after task save:", editedTasks);
  };

  const handleTaskDelete = (id) => {
    const original = editedTasks[id]?.original || "";
    updateRowField(id, { task_list: original });
    setEditedTasks((prev) => ({
      ...prev,
      [id]: { ...prev[id], value: original },
    }));
  };

  // 🔹 Common helper function
  const duplicateRowInState = (prevState, row, deptIndex, rowIndex) => {
    const newRows = [...prevState];
    const dept = newRows[deptIndex];

    const baseRowSnapshot = {
      user_id: row.user_id,
      project_id: row.project_id,
      date: row.date,
      work_status: row.work_status,
      task_list: row.task_list,
      work_hours: row.work_hours,
      project_manager_id: row.project_manager_id,
      work_till: row.work_till,
    };

    const newRow = {
      ...row,
      task_allocation_id: `temp-${Date.now()}`,
      isNew: true,
      baseRowSnapshot,
      isUpdated: true,
    };

    dept.data.splice(rowIndex + 1, 0, newRow);
    return newRows;
  };

  // 🔹 Main handler using the common function
  // const handleDuplicateRow = (row, deptIndex, rowIndex) => {
  //   setTableRows((prev) => duplicateRowInState(prev, row, deptIndex, rowIndex));
  //   setDuplicatedRows((prev) =>
  //     duplicateRowInState(prev, row, deptIndex, rowIndex)
  //   );
  // };

  const handleDuplicateRow = (row, deptIndex, rowIndex) => {
  const duplicated = duplicateRowInState(tableRows, row, deptIndex, rowIndex);

  // Update both states using same duplicated array to avoid re-running logic
  setTableRows(duplicated);
  setDuplicatedRows(duplicated);
};


  useEffect(() => {
  // console.log("duplicatedRows",duplicatedRows);
}, [duplicatedRows]);

  const handleProjectChangeCustom = (selectedProject, rowId) => {
    if (!selectedProject) return;

    updateRowField(rowId, {
      project_id: selectedProject.project_id,
      project_title: selectedProject.title,
    });
  };

  const renderNameCell = (params) => {
    const row = params.row;

    if (row.isGroup) {
      return (
        <Box
          display="flex"
          alignItems="center"
          py={2}
          sx={{ overflow: "hidden", width: "100%", px: "4px" }}
        >
          <Tooltip title={row.name} placement="top" arrow disableHoverListener={nameColumnWidth > 150}>
            <Typography
              fontWeight={600}
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
                fontSize: 14,
              }}
            >
              {row.name}
            </Typography>
          </Tooltip>
        </Box>
      );
    }

    return (
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Tooltip
          title={
            <div style={{ display: "flex", flexDirection: "column", gap: "2px"}}>
              <div style={{ fontWeight: 600, fontSize: "12px" }}>{row.user_name}</div>
              <div style={{ fontSize: "11px", opacity: 0.9 }}>
                {row.designation} | {row.relevant_experience}
              </div>
            </div>
          }
          placement="top"
          arrow
          disableHoverListener={nameColumnWidth > 150}
        >
          <Box
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <Typography
              className="timelog-user"
              noWrap
              sx={{
                alignSelf: "start",
                textAlign: "start",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              {row.user_name}
            </Typography>
            <Typography
              noWrap
              sx={{
                fontSize: 12,
                color: "#838088",
                alignSelf: "start",
                textAlign: "start",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              {row.designation} | {row.relevant_experience}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    );
  };

  const handleRemoveDuplicate = (task_allocation_id) => {
    setTableRows((prev) => {
      return prev.map((dept) => {
        const filteredData = dept.data.filter(
          (r) => r.task_allocation_id !== task_allocation_id
        );
        return { ...dept, data: filteredData };
      });
    });
  };

    const handleRefresh = async (e) => {
    e.stopPropagation();
    try {
      setLoading(true); // manually show loader
      await projectNames(); // triggers RTK refetch
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false); // hide loader regardless of result
    }
  };

  // const renderActionCell = (params) => {
  //   const row = params.row;
  //   const deptIndex = tableRows.findIndex((dept) =>
  //     dept?.data?.some(
  //       (r) => r.task_allocation_id === params.row.task_allocation_id
  //     )
  //   );
  //   const rowIndex = tableRows[deptIndex]?.data?.findIndex(
  //     (r) => r.task_allocation_id === params.row.task_allocation_id
  //   );

  //   if (row.isGroup) return null;

  //   return (
  //     <div
  //       className="d-flex gap-2 align-items-center justify-content-center"
  //       style={{ paddingTop: 10, height: 80 }}
  //     >
  //       <IconButton
  //         size="small"
  //         sx={{
  //           height: 40,
  //           width: 30,
  //           backgroundColor: isDarkMode ? "transparent" : "#F6F7F9",
  //           borderRadius: 10,
  //         }}
  //         onClick={() => handleDuplicateRow(params.row, deptIndex, rowIndex)}
  //       >
  //         <AddIcon
  //           fontSize="small"
  //           sx={{
  //             fontSize: 20,
  //             color: "#000000",
  //           }}

  //         />
  //       </IconButton>
  //       <Button variant="outlined" onClick={() => handleDeleteRow(row)}>
  //         <img src={Delete} alt="Delete" height={18} width={18} />
  //       </Button>
  //     </div>
  //   );
  // };
  const renderActionCell = (params) => {
    const row = params.row;

    // if (row.isGroup) return null;
    if (row.isGroup) {
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          {/* <IconButton onClick={() => handleToggle(row.id)} size="small"> */}
          <IconButton 
            onClick={() => handleToggle(row.id)} 
            size="small"
            sx={{
              padding: "10px",
              height: 40,
              width: 40,
              backgroundColor: "transparent",
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.1)" : "#e0e0e0",
              }
            }}
          >
            {expandedGroups[row.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      );
    }

    const deptIndex = tableRows.findIndex((dept) =>
      dept?.data?.some((r) => r.task_allocation_id === row.task_allocation_id)
    );
    const rowIndex = tableRows[deptIndex]?.data?.findIndex(
      (r) => r.task_allocation_id === row.task_allocation_id
    );

    return (
      <div
        className="d-flex gap-2 align-items-center justify-content-center"
        style={{ paddingTop: 10, height: 80 }}
      >
        {/* Show for original rows only */}
        {!row.isNew && (
          <>
            {/* Duplicate Button */}
            <Tooltip title="Duplicate">
              <IconButton
                size="small"
                sx={{
                  height: 40,
                  width: 40,
                  backgroundColor: "transparent",
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.1)" : "#e0e0e0",
                  }
                }}
                onClick={() => handleDuplicateRow(row, deptIndex, rowIndex)}
              >
                <AddIcon
                  fontSize="small"
                  sx={{ fontSize: 20, color: "#000000" }}
                />
              </IconButton>
            </Tooltip>

            {/* Delete Image Button */}
            <Tooltip title="Delete">
              <IconButton
                size="small"
                onClick={() => handleDeleteRow(row)}
                sx={{
                  height: 40,
                  width: 40,
                  backgroundColor: "transparent",
                  borderRadius: "50%",
                  marginLeft:"10px",
                  "&:hover": {
                    backgroundColor: isDarkMode ? "rgba(255, 0, 0, 0.1)" : "#ffebee",
                  }
                }}
              >
                <img src={Delete} alt="Delete" height={18} width={18} />
              </IconButton>
            </Tooltip>
          </>
        )}

        {/* Show only for duplicated rows */}
        {row.isNew && (
          <Tooltip title="Remove">
            <IconButton
              size="small"
              sx={{
                height: 40,
                width: 40,
                backgroundColor: "transparent",
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.1)" : "#e0e0e0",
                }
              }}
              onClick={() => handleRemoveDuplicate(row.task_allocation_id)}
            >
              <CloseIcon
                fontSize="small"
                sx={{ fontSize: 20, color: "#de1111ff" }}
              />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );
  };

  const renderWorkStatusCell = (params) => {
    const row = params.row;

    if (row.isGroup) return null;

    const statusValue = row.work_status;

    const statusObj = filterOptions.status.find(
      (opt) => opt.value === statusValue
    );
    const statusLabel = statusObj?.label || "";

    let statusClassName = "";
    switch (statusValue) {
      case "BENCH":
        statusClassName = "bench-status-select";
        break;
      case "ENGAGED":
        statusClassName = "engaged-status-select";
        break;
      case "SHORTLY_AVAILABLE":
        statusClassName = "shortly-status-select";
        break;
      case "LONG_TERM":
      case "LONG-TERM":
        statusClassName = "longterm-status-select";
        break;
      default:
        statusClassName = "";
    }

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: 80,
        }}
      >
        <FormControl size="small" sx={{ width: 150 }}>
          <Select
            value={statusValue}
            onChange={(e) => handleStatusChange(e, row.id)}
            input={<OutlinedInput className={statusClassName} />}
            className={statusClassName}
            MenuProps={{ transitionDuration: { enter: 150, exit: 250 } }}
            sx={{
              fontWeight: 600,
              borderRadius: "8px",
            }}
          >
            {filterOptions.status.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const renderTaskListCell = (params) => {
    const row = params.row;
    if (row.isGroup) return null;
    const taskState = editedTasks[row.id] || {
      value: row.task_list,
      original: row.task_list,
    };

    return (
      <Box
        // sx={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        //   width: "100%",
        //   height: 80,
        // }}
        sx={{
          width: 250,
          height: 100,
          overflow: "auto",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          scrollbarWidth: "none",
          display: "flex",
                                  alignItems:
                                    taskState.value?.length <= 5
                                      ? "center"
                                      : "flex-start",
                                  justifyContent:
                                    taskState.value?.length <= 5
                                      ? "center"
                                      : "flex-start",
                                  textAlign:
                                    taskState.value?.length <= 5
                                      ? "center"
                                      : "left",
                                  "&::-webkit-scrollbar": {
                                    display: "none",
                                  },
                                  padding: "8px",
                                }}
      >
        {/* <TextField
          multiline
          minRows={2}
          value={taskState.value}
          // onChange={(e) => {
          //   const newValue = e.target.value;
          //   handleTaskChange(row.id, newValue);
          //   // handleTaskSave(row.id, newValue);
          // }}
          onBlur={(e) => {
            const newValue = e.target.value;
            handleTaskChange(row.id, newValue); // Or call handleTaskSave directly
          }}
          // onBlur={() => handleTaskSave(row.id, taskState.value)}
          onKeyDown={(e) => e.stopPropagation()}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: 13,
              backgroundColor: "#F6F6F6",
              padding: "6px 12px",
              borderRadius: "8px",
              width: "100%",
              whiteSpace: "pre-wrap", // Ensures line breaks show correctly
            },
          }}
          sx={{
            textarea: {
              resize: "none", // Prevents manual resizing if you want to control height
            },
          }}
        /> */}
        <TextField
          multiline
          placeholder="Enter description"
          minRows={2}
          defaultValue={taskState.value}
          onBlur={(e) => {
            const newValue = e.target.value;
            handleTaskChange(row.id, newValue);
            handleTaskSave(row.id, newValue);
          }}
          onKeyDown={(e) => e.stopPropagation()}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: 13,
              backgroundColor: "#F6F6F6",
              padding: "6px 12px",
              borderRadius: "8px",
              width: "100%",
              whiteSpace: "pre-wrap",
            },
          }}
          sx={{
            textarea: {
              resize: "none",
            },
          }}
        />
      </Box>
    );
  };

  const renderProjectsCell = (params) => {
    const row = params.row;
    if (row.isGroup) return null;
    return (
      <Box
        sx={{
          width: "100%",
          height: 80,
          display: "flex",
          alignItems: "center",
          paddingX: 1,
        }}
      >
        <Autocomplete
          fullWidth
          size="small"
          options={project_list}
          getOptionLabel={(option) => option.title || ""}
          value={
            project_list.find((p) => p.project_id === row.project_id) || null
          }
          onChange={(e, newValue) => {
            handleProjectChangeCustom(newValue, row.id);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select Project"
              variant="standard"
              onKeyDown={(e) => e.stopPropagation()}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                sx: {
                  fontWeight: 500,
                  fontSize: 13,
                  color: "#4A4A4A",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "8px",
                  padding: "6px 12px",
                  height: 36,
                },
              }}
            />
          )}
          sx={{
            width: "100%", // 🔑 Important for full column width
          }}
          isOptionEqualToValue={(option, value) =>
            option.project_id === value.project_id
          }
        />
      </Box>
    );
  };

  const renderWorkHoursCell = (params) => {
    const row = params.row;
    if (row.isGroup) return null;
    const workHours = row.work_hours;

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: 80,
          overflow: "visible",
        }}
      >
        <FormControl size="small">
          <Select
            value={workHours}
            onChange={(e) => {
              const newWorkHour = e.target.value;

              handleWorkHoursChange(e, row.id);
              // console.log("Status changed to:", newWorkHour);
            }}
            variant="standard"
            disableUnderline
            MenuProps={{ transitionDuration: { enter: 150, exit: 250 } }}
            sx={{
              width: 100,
              fontWeight: 500,
              fontSize: 13,
              color: "#4A4A4A",
              backgroundColor: "#F6F6F6",
              borderRadius: "8px",
              padding: "6px 12px",
              height: 36,
              ".MuiSelect-icon": {
                color: "#666",
              },
            }}
          >
            {filterOptions.workHours.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const renderProjectManagersCell = (params) => {
    const row = params.row;
    if (row.isGroup) return "";

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: 80,
        }}
      >
        <FormControl size="small">
          <Select
            value={row.project_manager_id ?? ""}
            onChange={(e) => handleManagerChange(e, row.id)}
            variant="standard"
            disableUnderline
            MenuProps={{ transitionDuration: { enter: 150, exit: 250 } }}
            sx={{
              width: 150,
              fontWeight: 500,
              fontSize: 13,
              color: "#4A4A4A",
              backgroundColor: "#F6F6F6",
              borderRadius: "8px",
              padding: "6px 12px",
              height: 36,
              ".MuiSelect-icon": {
                color: "#666",
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Manager
            </MenuItem>
            {manager_lists.map((option, index) => (
              <MenuItem key={index} value={option.user_id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const renderWorkTillCell = (params) => {
    const row = params.row;
    // console.log("params_date :", row);

    if (row.isGroup) return null;

    const handleOpenCalendar = (event) => {
      setSelectedRowId(row.task_allocation_id);
      setSelectedDate(row.work_till ? new Date(row.work_till) : new Date());
      setAnchorEl(event.currentTarget);
      setCalendarOpen(true);
    };
    const getColorForDate = (dateStr) => {
      if (!dateStr) return "#9e9e9e"; // gray

      const today = dayjs();
      const date = dayjs(dateStr);
      const twoMonthsAgo = today.subtract(2, "month");

      if (date.isAfter(today)) {
        return "var(--longterm-text)"; // green
      } else if (date.isBefore(twoMonthsAgo)) {
        return "var(--shortly-text)"; // purple
      } else {
        return "var(--bench-text)"; // red
      }
    };

    const displayDate = row.work_till
      ? dayjs(row.work_till).format("DD/MM/YYYY")
      : "Select Date";
    const color = getColorForDate(row.work_till);
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: 80,
        }}
      >
        <Box
          onClick={handleOpenCalendar}
          sx={{
            cursor: "pointer",
            fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" },
            color: `${color} !important`,
            backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "",
            border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.15)" : "1px solid #e2e8f0",
            borderRadius: "6px",
            padding: "4px 12px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.16)" : "#e2e8f0",
              borderColor: isDarkMode ? "rgba(255, 255, 255, 0.3)" : "#cbd5e1",
            }
          }}
        >
          <CalendarTodayIcon sx={{ fontSize: "1rem", marginRight:"5px", marginBottom:"2px" }} />
          {displayDate}
        </Box>

        {/* Calendar Popover */}
        <Popover
          open={calendarOpen && selectedRowId === row.task_allocation_id}
          anchorEl={anchorEl}
          onClose={() => setCalendarOpen(false)}
          transitionDuration={{ enter: 100, exit: 250 }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          PaperProps={{
            style: {
              padding: "0px",
              minWidth: "320px",
              border: "1px solid green",
              overflow: "hidden",
              borderRadius: "8px",
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateCalendar
              value={selectedDate}
              onChange={(newDate) => {
                setSelectedDate(newDate);
                setCalendarOpen(false);
                updateRowField(row.task_allocation_id, {
                  work_till: newDate.toISOString(),
                });
              }}
            />
          </LocalizationProvider>
        </Popover>
      </Box>
    );
  };

  const renderOtherDetailsCell = (params) => {
    const row = params.row;
    if (row.isGroup) return null;
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: 80,
        }}
      >
        <IconButton
          sx={{
            color: "#4A4A4A",
            backgroundColor: "var(--cell-bg-color)",
            borderRadius: "10px",

            height: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => {
            setShowStaffInfo(!showStaffInfo);
            setSelectedStaff(row);
            // console.log("Row data:", row);
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      </Box>
    );
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: renderActionCell,
    },
    {
      field: "name",
      headerName: "Name",
      width: nameColumnWidth,
      minWidth: 10,
      resizable: true,
      renderCell: renderNameCell,
      headerClassName: "sticky-column",
      cellClassName: "sticky-column",
      renderHeader: () => (
        <Tooltip title="Name" placement="top" arrow disableHoverListener={nameColumnWidth > 60}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Name</span>
        </Tooltip>
      ),
    }, 
    {
      field: "project_title",
      headerName: "Projects",
      width: 300,
      renderCell: renderProjectsCell,
      renderHeader: () => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Projects</span>
          <Tooltip title="Refresh">
            <span
              style={{
                cursor: project_loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
              }}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   if (!project_loading) projectNames();
              // }}
              onClick={handleRefresh}
            >
              <FiRefreshCw color="teal" opacity={0.8} fontSize={16} />
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "task_list",
      headerName: "Task List",
      width: 300,
      renderCell: renderTaskListCell,
    },
    {
      field: "project_manager",
      headerName: "Project Manager",
      renderCell: renderProjectManagersCell,
      width: 180,
    },
    {
      field: "work_status",
      headerName: "Work Status",
      width: 200,
      renderCell: renderWorkStatusCell,
    },
    {
      field: "work_hours",
      headerName: "Work Hours",
      width: 200,
      renderCell: renderWorkHoursCell,
    },
    {
      field: "work_till",
      headerName: "Work Till",
      renderCell: renderWorkTillCell,
      width: 150,
    },
    {
      field: "otherDetails",
      headerName: "Other Details",
      width: 150,
      renderCell: renderOtherDetailsCell,
    },
  ];

  const handleOptionsClick = (event) => {
    setAnchorElOptions(event.currentTarget);
  };

  const handleOptionsClose = () => {
    setAnchorElOptions(null);
  };

  const handleDuplicateTable = () => {
    setPublish(!publish);
    handleOptionsClose();
  };

  // const handleTableExport = async () => {
  //   const requestedData = {
  //     date: format(selectionRange.startDate, "dd-MM-yyyy"),
  //   };
  //   // if (userId) {
  //   //   requestedData.user_id = userId;
  //   // }
  //   try {
  //     const response = await createEntity(
  //       "task-allocation/export",
  //       requestedData
  //     );
  //     if (response?.doc_url) {
  //       toast.success(response.message);

  //       // Trigger the download
  //       const link = document.createElement("a");
  //       link.href = response.doc_url;
  //       link.setAttribute("download", "");
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();

  //     }
  //   } catch (error) {
  //     toast.error(error.message);
  //   }

  //   handleOptionsClose();
  // };

  const handleTableExport = async () => {
    handleOptionsClose();

    // Close any existing popup first
    Swal.close();

    const result = await Swal.fire({
      title: "Export Confirmation",
      text: "Are you sure you want to export the Task Allocation report?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#04a189",
      cancelButtonColor: "#d33",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      await executeTableExport();
    }
  };

  const executeTableExport = async () => {
    const requestedData = {
      date: format(selectionRange.startDate, "dd-MM-yyyy"),
      department_id: departmentFilter,
      search: debouncedSearchTerm,
      isExport: true,
    };

    try {
      const response = await filterEntities(
        "task-allocation/view",
        requestedData
      );

      if (response) {
        const { file_url } = response.data;
        // console.log("doc_urls2 : ", response);
        const link = document.createElement("a");
        link.href = file_url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
        // const formattedDocUrl = doc_url.replace(/\\/g, "/"); // Replace backslashes
        // window.open(formattedDocUrl, "_blank");
        toast.success("Task Allocation report has been exported successfully");
      }
    } catch (error) {
      toast.error(error.message || "Export failed");
    }

    handleOptionsClose();
  };

  const handleArrowClick = (direction) => {
    const currentDate = selectionRange.startDate;

    const newDate =
      direction === "prev"
        ? new Date(currentDate.setDate(currentDate.getDate() - 1))
        : new Date(currentDate.setDate(currentDate.getDate() + 1));

    setSelectionRange({
      startDate: newDate,
      endDate: newDate,
      key: "selection",
    });
  };

  const confirmClosePublish = async () => {
    const result = await Swal.fire({
      title: "Cancel Publish",
      text: "Are you sure you want to cancel? If you cancel this, your duplicated records will remain in drafts.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel",
      cancelButtonText: "No, Keep",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#04a189",
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      handleClosePublish();
    }
  };

  const handleClosePublish = () => {
    setPublish(!publish);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
    if (!publish) {

      task_allocation_refetch?.();
      full_task_allocation_data_refetch?.();
    }
  }
  // const handleDuplicateTaskAllocationTable = (date) => {
  //   setPublish(!publish);
  const handleDuplicateTaskAllocationTable = async (date) => {
    handleOptionsClose();
    setClnderOpen(false);

    const previousDate = selectionRange?.startDate || new Date();

    const formattedSource = format(previousDate, "dd/MM/yyyy");
    const formattedTarget = format(date, "dd/MM/yyyy");



    const result = await Swal.fire({
      title: "Confirm Duplication",
      html: `
        <style>
          .swal2-icon { border: none !important; margin-bottom: 15px !important; }
        </style>
        Are you sure you want to duplicate the records present on <br/> <b>${formattedSource}</b> to <b>${formattedTarget}</b>?
      `,
      iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#04a189" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>`,
      showCancelButton: true,
      confirmButtonText: "Yes, Duplicate",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#04a189",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      setPublish(!publish);

    const newRange = {
      startDate: startOfDay(previousDate),
      endDate: endOfDay(date),
      key: "selection",
    };

    setSelectionRange({
      startDate: newRange.endDate,
      endDate: newRange.startDate,
      key: "selection",
    });

      // setClnderOpen(false);
      // console.log("Start Date (from selection):", newRange.startDate);
      // console.log("End Date (newly picked):", newRange.endDate);
    }
  };
  const isButtonDisabled =
    (!isAnyRowUpdated &&
      task_allocation_data?.meta?.source !== "ASSIGN_TASK") ||
    creating_allocation;

  return (
    <>
      {task_alocation_loading ||
        creating_allocation ||
        _duplicate_task_alocation_loading ||
        loading ? (
        <Loader />
      ) : (
        <div style={{ padding: "16px 0px" }} className="bg-white">
          <Offcanvas
            placement="end"
            show={showStaffInfo}
            onHide={onCloseStaffInfo}
            style={{ width: "30%" }}
          >
            <OffcanvasBody>
              <StaffInfoCard onClose={onCloseStaffInfo} staff={selectedStaff} />
            </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
            placement="end"
            show={showDrafts}
            onHide={handleCloseDraft}
            style={{ width: "70%" }}
          >
            <OffcanvasBody>

              <DraftCards
                onClose={handleCloseDraft}
                date={date}
                refetchList={task_allocation_refetch}
                onRefresh={() => setRefreshKey((k) => k + 1)}
              />
            </OffcanvasBody>
          </Offcanvas>

          <Box sx={{ width: "100%", px: "0px" }} className="bg-transparent">
            <div 
              className="d-flex justify-content-between align-items-center flex-nowrap  gap-3"
              style={{
                border: isDarkMode
                  ? "1px solid rgba(255, 255, 255, 0.15)"
                  : "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: "6px",
                padding: "10px 12px",
                backgroundColor: isDarkMode ? "transparent" : "#fff",
                marginBottom: "15px"
              }}
            >
              <div className="d-flex align-items-center  gap-3">
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <Select
                    value={departmentFilter}
                    className="task-select"
                    displayEmpty
                    onChange={(e) => setDepartmentFilter(e.target.value)}
                  >
                    {allDepartments?.map((option) => (
                      <MenuItem
                        key={option.department_id}
                        value={option.department_id}
                        sx={{ color: "var(--text-color)" }}
                      >
                        {option.department_name === "All" ? "All Departments" : option.department_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div
                className="d-flex align-items-center justify-content-center gap-2"
                style={{ minWidth: 300 }}
              >
                {!publish && (
                  <IconButton
                    onClick={() => {
                      handleArrowClick("prev");
                    }}
                  >
                    <ArrowBackIosIcon sx={{ fontSize: 15, color: "black" }} />
                  </IconButton>
                )}
                <div>
                  <CustomTasksCalender
                    selectionRange={selectionRange}
                      setSelectionRange={setSelectionRange}
                      publish = {publish}
                  />
                </div>

                {!publish && (
                  <IconButton
                    onClick={() => {
                      handleArrowClick("next");
                    }}
                  >
                    <ArrowForwardIosIcon
                      sx={{ fontSize: 15, color: "black" }}
                    />
                  </IconButton>
                )}
              </div>

              {/* Right: Search, Clear Filter, Export */}
              <div className="d-flex align-items-center gap-3 flex-nowrap">
                {/* <Tooltip title="Draft">
                  <MdEditDocument
                    size={24}
                    color="rgb(15, 163, 141)"
                    cursor="pointer"
                    onClick={handleDraft}
                    // title="Draft"
                  />
                </Tooltip> */}
                <SearchBar
                  placeholder="Search Staff Name"
                  searchTerm={searchTerm}
                  onSearchChange={handleSearchChange}
                />

                {clearFilter && (
                  <button
                    className="btn btn-outline-secondary"
                    disabled={loading}
                    onClick={handleClearFilter}
                  >
                    Clear
                  </button>
                )}

                {publish ||
                  task_allocation_data?.meta?.source === "DUPLICATE" ? (
                  <Button
                    onClick={() => {
                      handlePublishAndSendMail();
                    }}
                    className=" add_btn"
                    style={{
                      backgroundColor: "var(--longterm-text)",
                      border: "none",
                    }}
                    disabled={creating_allocation}
                  >
                    Publish & Sent Mail
                  </Button>
                ) : (
                  <button
                    onClick={handleAssignTasks}
                    className="add_btn"
                    disabled={isButtonDisabled}
                    style={{
                      opacity: isButtonDisabled ? 0.5 : 1,
                      cursor: isButtonDisabled ? "not-allowed" : "pointer",
                      border: "none",
                    }}
                  >
                    Assign Tasks
                  </button>
                )}
                
                {publish ||
                  task_allocation_data?.meta?.source === "DUPLICATE" ? (
                  <IconButton
                    className="d-flex align-items-center justify-content-center"
                    sx={{
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      width: "36px",
                      height: "36px",
                    }}
                    // onClick={handleClosePublish}
                    onClick={confirmClosePublish}
                  >
                    <IoCloseOutline size={20} color={"var(--longterm-text)"} />
                  </IconButton>
                ) : (
                  <IconButton
                    className="d-flex align-items-center justify-content-center"
                    sx={{
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      width: "36px",
                      height: "36px",
                    }}
                    onClick={handleOptionsClick}
                  >
                    <SlOptions size={20} color="rgba(18, 183, 159, 1)" />
                  </IconButton>
                )}

                <Menu
                  anchorEl={anchorElOptions}
                  open={openOptions}
                  onClose={handleOptionsClose}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      borderRadius: 2,
                      mt: 1,
                      minWidth: 150,
                      backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
                      color: isDarkMode ? "#fff" : "inherit",
                      "& .MuiMenuItem-root": {
                        color: `${isDarkMode ? "#fff" : "inherit"} !important`,
                        "& .MuiListItemIcon-root": {
                          color: `${isDarkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.54)"} !important`,
                        },
                        "&:hover": {
                          backgroundColor: isDarkMode
                            ? "rgba(255, 255, 255, 0.08) !important"
                            : "rgba(0, 0, 0, 0.04) !important",
                        },
                      },
                    },
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <Tooltip 
                    title={!isButtonDisabled ? "Please assign your current changes before duplicating" : ""} 
                    placement="left"
                  >
                    <span>
                      <MenuItem
                        disabled={!isButtonDisabled}
                        onClick={() => {
                          setClnderOpen(true);
                        }}
                      >
                        <ListItemIcon>
                          <CalendarTodayIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Duplicate</ListItemText>
                      </MenuItem>
                    </span>
                  </Tooltip>
                  <MenuItem
                    onClick={() => {
                      setShowDrafts(true);
                      handleOptionsClose();
                    }}
                  >
                    <ListItemIcon>
                      <SaveAltSharp fontSize="small" cursor="pointer" />
                    </ListItemIcon>
                    <ListItemText>Draft</ListItemText>
                  </MenuItem>

                  <MenuItem onClick={handleTableExport}>
                    <ListItemIcon>
                      <CiExport 
                        size={18}
                        cursor="pointer" 
                        style={{ strokeWidth: "1.5", color: isDarkMode ? "#fff" : "rgba(64, 62, 62, 0.54)" }}
                      />
                    </ListItemIcon>
                    <ListItemText>Export</ListItemText>
                  </MenuItem>
                </Menu>

                <Popover
                  open={clndrOpen}
                  onClose={() => {
                    setClnderOpen(false);
                  }}
                  anchorReference="none"
                  PaperProps={{
                    style: {
                      padding: "0px",
                      top: "50%",
                      right: 0,
                      position: "absolute",
                      transform: "translate(-50%,-50%)",
                      overflow: "hidden",
                      borderRadius: "8px",
                    },
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateCalendar
                      value={selectionRange.startDate}
                        onChange={handleDuplicateTaskAllocationTable}
                      // shouldDisableDate={(date) => startOfDay(date) < startOfDay(new Date())}
                    />
                  </LocalizationProvider>
                </Popover>
              </div>
            </div>
          </Box>

          {/* <div className="mt-2">
            <DataGrid
              rows={getVisibleRows()}
              columns={columns}
              getRowId={(row) => row.id?.toString?.() || String(Math.random())}
              autoHeight
              loading={task_alocation_loading}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              // onRowClick={(row) => console.log("particular_row :", row)}
              pagination
              pageSizeOptions={[50, 75, 100]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "var(--cell-bg-color)",
                  fontWeight: "bold",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "13px",
                  color: "#444",
                  whiteSpace: "normal !important",
                  wordBreak: "break-word",
                  alignItems: "start", //
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f9f9f9",
                },
                "& .sticky-column": {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "var(--cell-bg-color)",
                },
                "& .action-col": {
                  left: 200, // 👈 equal to name column width
                },
              }}
            />
          </div> */}
          <div className="mt-2">
            <DataGrid
              rows={paginatedRows}
              columns={columns}
              // getRowId={(row) => row.id?.toString?.() || String(Math.random())}
              getRowId={(row) => row.task_allocation_id || row.department_id || row.id || String(Math.random())}
              autoHeight
              loading={task_alocation_loading}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              pagination={false}
              disableColumnMenu
              disableColumnSorting
              disableColumnFilter
              disableColumnSelector
              onColumnWidthChange={(params) => {
                if (params.colDef.field === "name") {
                  setNameColumnWidth(params.width);
                }
              }}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
                footer: () => (
                  <CustomPaginationFooter
                    page={paginationModel.page}
                    pageSize={paginationModel.pageSize}
                    rowCount={visibleRows.length}
                    onPageChange={(newPage) =>
                      setPaginationModel((prev) => ({ ...prev, page: newPage }))
                    }
                    onPageSizeChange={(newPageSize) =>
                      setPaginationModel({ page: 0, pageSize: newPageSize })
                    }
                  />
                ),
              }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "var(--cell-bg-color)",
                  fontWeight: "bold",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid var(--table-border-color)",
                  borderLeft: "1px solid var(--table-border-color)",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                // Show resize handle ONLY for Name column
                "& [data-field='name'] .MuiDataGrid-columnSeparator": {
                  display: "flex",
                  visibility: "visible",
                  color: "#1976d2",
                  opacity: 0,
                  transition: "opacity 0.2s ease",
                },
                "& [data-field='name']:hover .MuiDataGrid-columnSeparator": {
                  opacity: 1,
                },
                "& [data-field='name'] .MuiDataGrid-columnSeparator:hover": {
                  color: "#1565c0",
                  opacity: 1,
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "13px",
                  color: "#444",
                  whiteSpace: "normal !important",
                  wordBreak: "break-word",
                  alignItems: "start",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f9f9f9",
                },
                "& .sticky-column": {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "var(--cell-bg-color)",
                },
                "& .action-col": {
                  left: nameColumnWidth,
                },
              }}
            />
          </div>
          {/* <DeleteConfirmationModal
            open={openDeleteModal}
            onClose={() => setOpenDeleteModal(false)}
            onConfirm={handleDeleteConfirmed}
            deleteIcon={DeleteWhite}
            loading={loading}
          /> */}
          <CommonDelete
            open={openDeleteModal}
            handleClose={() => setOpenDeleteModal(false)}
            name="User"
            selectedTask={selectedTask}
            refetchList={duplicate_task_allocation_refetch}
            task_allocation_refetch={task_allocation_refetch}
            task_allocation_data={task_allocation_data}
            full_task_allocation_data_refetch={
              full_task_allocation_data_refetch}
            refetchListTwo={full_duplicate_task_allocation_refetch}
            source={source}
            date={date}
            isDraft={draft}
            publish={publish}
            isButtonDisabled={isButtonDisabled} 
            selectionRange={selectionRange}
            // setPublish={setPublish}
          />
        </div>
      )}
    </>
  );
}

export default TasksAllocationsTab;
